// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonPage_wrapper__03m2h","person__name":"PersonPage_person__name__b6Syb","container":"PersonPage_container__Si-XY"};